export function Dashboard() {
  return <h1 className="mb-6 font-sans text-2xl font-bold">STRONA GŁÓWNA</h1>;
}

export default Dashboard;
